<template>
  <form ref="form" :action="action" method="POST" @submit.prevent="submit">
    <input ref="csrf" type="hidden" name="authenticity_token" :value="csrfToken" />
    <div class="mb-4">
      <h1>{{ translations.heading }}</h1>
      <Input
        required
        :label="translations.form.company_name.label"
        name="company_name"
        type="text"
        :placeholder="translations.form.company_name.placeholder"
      />
      <Input
        required
        :label="translations.form.company_legal_name.label"
        name="company_legal_name"
        type="text"
        :placeholder="translations.form.company_legal_name.placeholder"
      />
      <div class="form-row">
        <div class="col-sm-16">
          <Input
            required
            :label="translations.form.street.label"
            name="street"
            type="text"
            :placeholder="translations.form.street.placeholder"
          />
        </div>
        <div class="col-sm-8">
          <Input
            required
            :label="translations.form.street_number.label"
            name="street_number"
            type="text"
            :placeholder="translations.form.street_number.placeholder"
          />
        </div>
      </div>
      <Input
        required
        :label="translations.form.postal_code.label"
        name="postal_code"
        type="text"
        :placeholder="translations.form.postal_code.placeholder"
      />
      <Input
        required
        :label="translations.form.city.label"
        name="city"
        type="text"
        :placeholder="translations.form.city.placeholder"
      />
      <label>{{ translations.form.country.label }}</label>
      <select required :label="translations.form.country.label" name="country" class="form-control">
        <option v-for="country in countries" :key="country.iso" :value="country.iso">
          {{ country.label }}
        </option>
      </select>
    </div>
    <div class="mb-3">
      <p class="h4">Weitere Daten</p>
      <Input
        required
        :label="translations.form.first_name.label"
        name="name"
        type="text"
        :placeholder="translations.form.first_name.placeholder"
      />
      <Input
        required
        :label="translations.form.surname.label"
        name="surname"
        type="text"
        :placeholder="translations.form.surname.placeholder"
      />
    </div>
    <div class="mb-3">
      <slot></slot>
    </div>

    <button type="submit" class="btn btn-primary btn-lg btn-block">
      {{ translations.form.submit }}
    </button>
  </form>
</template>

<script>
import Input from "../forms/Input";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "OnboardingSignupForm",
  components: {
    Input,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
    }),
  },
  methods: {
    ...mapActions({
      fetchCsrfToken: "fetchCsrfToken",
      setLoadingOverlayVisibility: "onboarding/setLoadingOverlayVisibility",
    }),
    async submit() {
      let { form } = this.$refs;
      if (form.checkValidity()) {
        await this.fetchCsrfToken();
        this.$nextTick(function() {
          form.submit();
        });
        this.setLoadingOverlayVisibility(true);
      } else {
        form.reportValidity();
      }
    },
  },
};
</script>
